export function clamp(lower: number, upper: number) {
  return (number: number) => Math.max(lower, Math.min(number, upper));
}
